<template>
    <add-profile-dialog ref="addProfileDialog"
                        class="fb-add-profile-dialog"
                        :profile-type="profileTypes.instagramCompetitor"
                        :enable-next-btn="enableNext"
                        :next-btn-text="nextBtnText"
                        :show-progress-bar="!!selectedPageType"
                        :cur-stage="curStage"
                        :total-stages="totalStages"
                        :show-prev-btn="!saving"
                        :show-next-btn="!saving"
                        @close="$emit('close')"
                        @prev="previous"
                        @next="next">
        <template #workflow>
            <keep-alive>
                <h4>Add a LinkedIn Competitor Profile</h4>

                <LinkedInUnauthorisedProfileSearch v-if="isSearchStage" @selected-channel="selectedChannel = $event"/>

                <edit-public-profile v-if="isEditStage"/>


                <saving-item v-if="saving" :saving-message="saveMessage" :save-complete="saveComplete"
                             :save-complete-message="saveCompleteMessage" :save-error="saveError"
                             :save-error-message="saveErrorMessage">
                </saving-item>

            </keep-alive>
        </template>
    </add-profile-dialog>

</template>

<script>
import AddProfileDialog from "@/setup/profiles/add-profile/AddProfileDialog.vue";
import VuexStore from "@/store/vuex/VuexStore";
import {addProfileMixins} from "@/setup/profiles/add-profile/AddProfileMixins";
import EditPublicProfile from "@/setup/profiles/add-profile/EditPublicProfile.vue";
import SavingItem from "@/setup/SavingItem.vue";
import LinkedInUnauthorisedProfileSearch
    from "@/setup/profiles/add-profile/linkedin-unauthorised/LinkedInUnauthorisedProfileSearch.vue";
import {profileTypes} from "@/setup/profiles/ProfileUtils";

export default {
    name: "LinkedinUnauthorisedProfileDialog",
    store: VuexStore,
    components: {
        LinkedInUnauthorisedProfileSearch, SavingItem, EditPublicProfile, AddProfileDialog
    },
    mixins: [addProfileMixins],
    data: function () {
        return {
            loggedInThroughFacebook: false,
            checkingFbLoginStatus: false,
            curStage: 1,
            totalStages: 3,
            selectedPageType: null,
            selectedChannel: null
        }
    },

    computed: {

        isSearchStage() {
            return !this.saving && this.curStage === this.addProfileStages.linkedin.public.company.SEARCH_PAGE
        },

        isEditStage() {
            return !this.saving && this.curStage === this.addProfileStages.linkedin.public.company.EDIT_PAGE
        },

        enableNext() {
            // If we are on the edit stage, we only allow saving if the profile has a category set
            if (this.curStage === this.addProfileStages.linkedin.public.company.EDIT_PAGE) {
                return !!this.newProfileData.publicProfile?.media
            }
            // If we are on the search stage, we only enable next if the profile is not currently in the account (check "existing" field)
            if (this.curStage === this.addProfileStages.linkedin.public.company.SEARCH_PAGE) {
                return !this.newProfileData.publicProfile?.existing && !!this.newProfileData.publicProfile;
            }

            return false;
        },

        nextBtnText() {
            // if we are on the final stage, show "Save" instead of "Next"
            return this.curStage === this.totalStages - 1 ? "Save" : "Next";
        }
    },

    methods: {
        next() {
            this.curStage++;

            if (this.curStage === this.totalStages) {
                this.savePublicProfile(profileTypes.linkedin_unauthorised_company);
            }
        },

        previous() {
            this.curStage--;

            if (this.curStage === 0) {
                this.curStage = 1;
                this.selectedPageType = null;
            }
        },

    }
}
</script>

<style scoped lang="sass">

</style>